// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyUpdate_container__1-wfT","form":"CompanyUpdate_form__1VNHd"};